(() => {
  const root = document.querySelector('[data-manual-hub]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const languages = ['nl', 'en', 'fr', 'de', 'ru'];
  const panels = [...root.querySelectorAll('[data-manual-panel]')];
  const links = [...root.querySelectorAll('[data-manual-language]')];
  const products = new Set([...root.querySelectorAll('[data-product-id]')].map(el => el.dataset.productId));
  let activeLanguage = 'nl';
  let selectedProduct = '';
  const parsedHash = () => {
    let hash;
    try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return {}; }
    const panelLanguage = hash.startsWith('manuals-') ? hash.slice(8) : '';
    if (languages.includes(panelLanguage)) return { language: panelLanguage };
    if (products.has(hash)) return { product: hash };
    for (const language of languages) {
      const suffix = `-${language}`;
      if (hash.endsWith(suffix) && products.has(hash.slice(0, -suffix.length))) {
        return { product: hash.slice(0, -suffix.length), language };
      }
    }
    return {};
  };
  function render(language, product, scroll = false) {
    activeLanguage = language;
    selectedProduct = products.has(product) ? product : '';
    panels.forEach(panel => { panel.hidden = panel.dataset.manualPanel !== language; });
    links.forEach(link => {
      if (link.dataset.manualLanguage === language) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    if (selectedProduct) {
      const detail = document.getElementById(`${selectedProduct}-${language}`);
      detail.open = true;
      if (scroll) {
        detail.querySelector('summary').focus({ preventScroll: true });
        detail.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
  }
  function sync(scroll = false) {
    const url = new URL(location.href);
    const hash = parsedHash();
    const explicit = url.searchParams.get('lang');
    const browserLanguage = (navigator.language || '').split('-')[0];
    const pageLanguage = document.documentElement.lang.split('-')[0];
    const language = languages.includes(explicit) ? explicit : hash.language || (languages.includes(pageLanguage) ? pageLanguage : (languages.includes(browserLanguage) ? browserLanguage : 'nl'));
    render(language, hash.product || '', scroll);
  }
  function navigate(language, product, scroll) {
    const url = new URL(location.href);
    url.searchParams.set('lang', language);
    url.hash = product || `manuals-${language}`;
    history.pushState(null, '', url);
    render(language, product, scroll);
  }
  links.forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    navigate(link.dataset.manualLanguage, selectedProduct, false);
  }));
  root.querySelectorAll('[data-manual-product]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    navigate(activeLanguage, link.dataset.manualProduct, true);
  }));
  root.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', () => {
    const detail = summary.parentElement;
    if (!detail.open) {
      selectedProduct = detail.dataset.productId;
      const url = new URL(location.href);
      url.searchParams.set('lang', activeLanguage);
      url.hash = selectedProduct;
      history.replaceState(null, '', url);
    }
  }));
  window.addEventListener('popstate', () => sync(true));
  window.addEventListener('hashchange', () => sync(true));
  let beforePrint = [];
  window.addEventListener('beforeprint', () => {
    beforePrint = [...root.querySelectorAll('details')].map(detail => [detail, detail.open]);
    root.querySelectorAll('details').forEach(detail => { detail.open = true; });
  });
  window.addEventListener('afterprint', () => beforePrint.forEach(([detail, open]) => { detail.open = open; }));
  root.querySelectorAll('.blx-manuals-print').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => window.print());
  });
  sync(Boolean(parsedHash().product));
})();
